import { signOutFromFirebase } from "./firebaseAuth";
export const formatDate = (dateStr: string) => {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const getDayOfWeek = (dateStr: string) => {
  const days = [
    "Domingo",
    "Segunda Feira",
    "Terça Feira",
    "Quarta Feira",
    "Quinta Feira",
    "Sexta Feira",
    "Sábado",
  ];
  const date = new Date(dateStr);

  return days[date.getDay()];
};

export const formatTime = (dateStr: string) => {
  const date = new Date(dateStr);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${hours}:${minutes}`;
};

export const getCompanyData = () => {
  const value = localStorage.getItem("userSession");
  const companyData: { companyId?: string | number } = value
    ? JSON.parse(value)
    : {};

  return companyData;
};

export const isTokenExpired = (token: string): boolean => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );

    const payload = JSON.parse(jsonPayload);
    const currentTime = Math.floor(Date.now() / 1000);

    return payload.exp < currentTime + 300;
  } catch (error) {
    console.error("Erro ao verificar token:", error);
    return true;
  }
};

export const clearSessionData = async () => {
  localStorage.removeItem("token");
  localStorage.removeItem("userSession");
  await signOutFromFirebase();
};

export const isAuthenticated = (): boolean => {
  const token = localStorage.getItem("token");
  const session = localStorage.getItem("userSession");

  if (!token || !session) {
    return false;
  }

  if (isTokenExpired(token)) {
    clearSessionData().catch(console.error);
    return false;
  }

  try {
    const companyData = JSON.parse(session);
    return !!companyData.companyId;
  } catch (error) {
    console.error("Erro ao verificar dados da sessão:", error);
    clearSessionData().catch(console.error);
    return false;
  }
};
